<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col>
                <h5>{{Core.Definition.getDefinition('Modèle de semaine')}}</h5>
                <hr/>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <Request
                        ref="requestPublish"
                        root="/event-date/publish"
                        method="PUT"
                        :onRequestSuccess="updateEvents"
                        :onRequestError="requestError">
                    <slot slot="body">
                        <Request
                                ref="requestDays"
                                root="/event-week-template-date/days"
                                :onRequestSuccess="updateEvents"
                                :onRequestError="requestError">
                            <slot slot="body">
                                <b-card :class="dataEventCalendarStatus.cardClass">
                                    <b-row class="mb-4">
                                        <b-col>
                                            <b-badge style="position: absolute; z-index: 99999999" v-if="dataEventCalendarStatus.caption !== ''" class="p-2" :variant="dataEventCalendarStatus.badgeVariant">{{dataEventCalendarStatus.caption}}</b-badge>
                                        </b-col>
                                        <b-col class="text-right">
                                            <b-button-group>
                                                <b-button @click="onAddEvent" class="btn btn-light mr-2">{{Core.Definition.getDefinition('Nouvel événement')}}</b-button>
                                            </b-button-group>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <CalendarWeek
                                                    ref="calendarWeek"
                                                    :renderEventTitle="renderEventTitle"
                                                    :renderEventContent="renderEventContent"
                                                    :renderEventAlt="renderEventAlt"
                                                    :options="{
                                                            event: {
                                                                  defaultBGColor: '#333333',
                                                                },
                                                                date: {
                                                                    days: 7,
                                                                    firstDayOfWeek: 'monday',
                                                                    displayFormat: 'dddd'
                                                                },
                                                                time: {
                                                                    start: '07:00',
                                                                    end: '22:00',
                                                                    interval: '15'
                                                                }
                                                            }"
                                                    @onTimeClick="onTimeClick"
                                                    @onEventClick="onEventClick">
                                            </CalendarWeek>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </slot>
                        </Request>
                    </slot>
                </Request>

            </b-col>
        </b-row>

        <ModalEventDate
            ref="modalEventDate"
            :ignoreRouteParamId="true"
            :options="{
                defaultValue: {
                    status: 'publish'
                },
                format: {
                    value: 'd',
                    label: 'dddd',
                    startOf: 'isoWeek'
                },
                root: {
                    get: '/event-week-template-date',
                    save: '/event-week-template-date'
                }
            }"
            @onSave="onSaveEvent"
            @onSaveSuccess="request">
        </ModalEventDate>

    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import ModalConfirm from '../../components/ModalConfirm'
    import ModalEventDate from '../../components/ModalEventDate'
    import Request from '../../components/Request'
    import CalendarWeek from '../../components/CalendarWeek'
    export default {
        name: 'EventWeekTemplate',
        props: {
            options: {
                type: Object,
                default: function () {
                    return {
                        date: {
                            firstDayOfWeek: 'monday',
                        }
                    }
                }
            }
        },
        components: {
            ModalConfirm,
            Request,
            CalendarWeek,
            ModalEventDate
        },
        watch: {
        },
        mounted() {
            this.request()
        },
        data: function () {
            return {
                Core: window.Core,
                dataEvent: {
                    modal: {
                        show: true
                    }
                },
                dataEventCalendarStatus: {
                    caption: '',
                    badgeVariant: '',
                    cardClass: ''
                }
            }
        },
        methods: {
            onSaveEvent() {
                this.$refs.modalEventDate.$refs.dynamicForm.addSaveArg('eventWeekTemplateId', this.$route.params.id)
            },
            renderEventTitle(event) {
                if(event.status === 'draft') {
                    return event.title + '<i class="ml-1">(' + Core.Definition.getDefinition('Brouillons') + ')</i>'
                }
                return event.title
            },
            renderEventContent(event) {
                if (event.eventWeekTemplateDateUsers != null) {
                    return "<small>" + event.eventWeekTemplateDateUsers + "</small>"
                }
                return ''
            },
            renderEventAlt(event) {
                if(event.status === 'draft') {
                    return event.title + ' (' + Core.Definition.getDefinition('Brouillons') + ')'
                }
                return event.title
            },
            switchStatus(status) {
                switch(status){
                    case Mantle.EventCalendar.statusReady:
                        this.dataEventCalendarStatus.cardClass = 'card-accent-light'
                        this.dataEventCalendarStatus.badgeVariant = 'light'
                        this.dataEventCalendarStatus.caption = Core.Definition.getDefinition('')
                        break
                    case Mantle.EventCalendar.statusError:
                        this.dataEventCalendarStatus.cardClass = 'card-accent-danger'
                        this.dataEventCalendarStatus.badgeVariant = 'danger'
                        break
                    case Mantle.EventCalendar.statusLoading:
                        this.dataEventCalendarStatus.cardClass = 'card-accent-info'
                        this.dataEventCalendarStatus.badgeVariant = 'info'
                        this.dataEventCalendarStatus.caption = Core.Definition.getDefinition('Chargement de la semaine ...')
                        break
                    case Mantle.EventCalendar.statusPublishing:
                        this.dataEventCalendarStatus.cardClass = 'card-accent-info'
                        this.dataEventCalendarStatus.badgeVariant = 'info'
                        this.dataEventCalendarStatus.caption = Core.Definition.getDefinition('Publication en cours ...')
                        break
                    case Mantle.EventCalendar.statusSaving:
                        this.dataEventCalendarStatus.cardClass = 'card-accent-info'
                        this.dataEventCalendarStatus.badgeVariant = 'info'
                        this.dataEventCalendarStatus.caption = Core.Definition.getDefinition('Enregistrement en cours ...')
                        break
                    case Mantle.EventCalendar.statusRemoving:
                        this.dataEventCalendarStatus.cardClass = 'card-accent-warning'
                        this.dataEventCalendarStatus.badgeVariant = 'warning'
                        this.dataEventCalendarStatus.caption = Core.Definition.getDefinition('Supression en cours ...')
                        break
                    default:
                        break
                }
            },
            request() {
                this.switchStatus(Mantle.EventCalendar.statusLoading)
                if (Core.Validation.isId(this.$route.params.id)) {
                    this.$refs.requestDays.addArg('id', this.$route.params.id)
                    this.$refs.requestDays.request()
                }
            },
            requestError(data) {
            },
            onAddEvent(event) {
                this.$refs.modalEventDate.id = ''
                this.$refs.modalEventDate.date = Vue.moment().startOf('isoWeek').format('YYYY-MM-DD')
                this.$refs.modalEventDate.open = true
            },
            onTimeClick(date, time, dayOfWeek) {
                this.$refs.modalEventDate.id = ''
                this.$refs.modalEventDate.timeStart = time
                this.$refs.modalEventDate.timeEnd = Vue.moment(Vue.moment().format('YYYY-MM-DD ' + time)).add('hour', 1).format('HH:mm')
                this.$refs.modalEventDate.date = date
                this.$refs.modalEventDate.open = true
            },
            onEventClick(event, date) {
                if (Core.Validation.isId(event.id)) {
                    this.$refs.modalEventDate.id = event.id.toString()
                    this.$refs.modalEventDate.date = date
                    this.$refs.modalEventDate.open = true
                }
            },
            updateEvents(data) {
                let eventWeekTemplateDates = []

                if (data.eventWeekTemplateDates !== undefined) {
                    eventWeekTemplateDates = data.eventWeekTemplateDates
                }

                if (data.eventWeekTemplateDate !== undefined) {
                    eventWeekTemplateDates.push(data.eventWeekTemplateDate)
                }

                for(let eventWeekTemplateDate in eventWeekTemplateDates) {
                    eventWeekTemplateDate = eventWeekTemplateDates[eventWeekTemplateDate]
                    let start = eventWeekTemplateDate.start
                    let end = eventWeekTemplateDate.end
                    let dayOfWeek = eventWeekTemplateDate.dayOfWeek - 1
                    eventWeekTemplateDate.start = Vue.moment().startOf('isoWeek').add('day', dayOfWeek).format('YYYY-MM-DD') + ' ' + start
                    eventWeekTemplateDate.end = Vue.moment().startOf('isoWeek').add('day', dayOfWeek).format('YYYY-MM-DD') + ' ' + end
                    this.$refs.calendarWeek.updateEvent(eventWeekTemplateDate)
                }

                this.switchStatus(Mantle.EventCalendar.statusReady)
            }
        }
    }
</script>
